<template>
  <div class="modal custom-modal fade" id="edit-schedule-template-roles" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
         <div class="modal-header">
          <h5 class="modal-title">Edit Schedule Roles</h5>
          <button type="button" ref="Close" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          
            <v-select v-model="assginedRolesIds" :items="companyId" item-title="name" item-value="id"
              placeholder="select role" multiple chips closable-chips variant="outlined">
            </v-select>
            <div class="input-block mb-3 mt-3">
              <label class="col-form-label">Effective Date</label>
              <div class="cal-icon">
                <date-picker :inputFormat="'dd/MM/yyyy'" placeholder="Choose Date" class="form-control datetimepicker" :editable="true"
                  :clearable="false" v-model="effectiveDate" />
              </div>
              <small class="text-muted">Schedules will be regenerated from this date. Can be up to 1 month in the past.</small>
            </div>
            
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="updateUserSchedule"> <span v-if="!isLoading">Submit</span>
                <div class="spinner-border spinner-border-sm text-light" role="status" v-else>
                  <span class="visually-hidden">Loading...</span>
                </div></a>
              </div>
              <div class="col-6">
                <a href="javascript:void(0);" data-bs-dismiss="modal" class="btn btn-primary cancel-btn">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import {VUE_APP_API_BASE_URL} from "../../config";
import axios from 'axios';
import dayjs from "dayjs";
export default {
  data() {
    return {
      assginedRolesIds: [],
      companyId: [],
      templateId:'',
      isLoading:false,
      effectiveDate: new Date()
    };
  },
  mounted() {
      this.getCompanyRoles()
  },
  methods: {
    updateId(record){
      this.templateId = record;
      this.getTemplateAssignedRoles();
    },

    async getTemplateAssignedRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/schedule-template/${this.templateId}/assigned-roles`)
        .then((response) => {
          if (response.data.status) {
            this.assginedRolesIds = response.data.data
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
   
     async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyId = response.data.data
            this.companyId.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              // element['text'] = element['name'];
              // delete element['name'];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    updateUserSchedule() {
      this.isLoading = true;

      var Shift = {
        "schedule_template_id": this.templateId,
        "company_role_ids": this.assginedRolesIds,
        "effective_date": this.effectiveDate ? dayjs(this.effectiveDate).format("YYYY-MM-DD") : null
      }
      axios.post(`${VUE_APP_API_BASE_URL}/schedule-template/update-role`, Shift)
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.$emit("editedShift");
            this.$refs.Close.click();
            this.isLoading = false;
          } else {
            this.$toast.error(response.data.message || response.data.errors);
            this.isLoading = false;
            // this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.isLoading = false;
        });

    }
  }
};
</script>
